var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { getCalendarTimeOffs } from '../services/CalendarService';
import { calendarKeys } from './queryKeys';
export function useCalendarTimeOffs(params) {
    var _a, _b;
    const { range, filters, selectedTechnicianIds } = params;
    const rangeStart = (_a = range === null || range === void 0 ? void 0 : range.startStr) !== null && _a !== void 0 ? _a : '';
    const rangeEnd = (_b = range === null || range === void 0 ? void 0 : range.endStr) !== null && _b !== void 0 ? _b : '';
    return useQuery({
        queryKey: calendarKeys.timeOffs(rangeStart, rangeEnd, filters, selectedTechnicianIds),
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ signal }) {
            if (!range)
                throw new Error('No date range provided');
            const response = yield getCalendarTimeOffs({ range, filters, selectedTechnicianIds }, signal);
            if (response.error) {
                throw new Error(response.error.message);
            }
            return response.data;
        }),
        enabled: !!range,
        staleTime: 2 * 60 * 1000,
        keepPreviousData: true
    });
}
